enum EmailStatus {
  Sent = 1,
  Failed = 2,
}

export default EmailStatus;
